import HELPER from '@/app/utils/HELPER';
import { updateCurrentSettings } from '@/app/editor/sidebar/utils/gfSnippetSettingLinks';

(function (jQuery) {
  jQuery.gfSwitcher = function (element, options) {
    const defaults = {
      // LAZYLOADING2019
      enable: true,

      title: '',
      value: 0,
      onBeforeChanged: function (value, $element) {},
      onSelected: function (value, $element) {},
      className: '',
    };

    this.settings = {};
    const $element = jQuery(element);
    const _this = this;

    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();
      _this.setTemplate();

      $element.on('value-change', function () {
        const value = $(this).val();
        _this.setValue(value);
      });

      return false;
    };

    this.getController = function () {
      return $element.next('.gfSwitcher');
    };

    this.setTemplate = function () {
      let dataTitle;
      if (_this.settings.title == '') {
        dataTitle = 'none';
      } else {
        dataTitle = _this.settings.title;
      }
      const desc = typeof $element.attr('data-description') === 'undefined' ? '' : $element.attr('data-description');
      let _template = '<div class="gfSwitcher ' + _this.settings.className + '" data-title="' + dataTitle + '">';
      if (dataTitle != '' && dataTitle != 'none') {
        _template += '<div class="gfSGSubTitle gfSwitcherTitle">' + dataTitle + '</div>';
        _template += '<div class="gfSGclear"></div>';
      }
      // #LAZYLOADING2019
      _template +=
        '<div class="gfSwitcherSwitch' +
        (_this.settings.enable ? '' : ' disableSwitch') +
        '"><span></span><div class="gfSwitcherCircle"></div></div><div class="gfSwitcherDesc">' +
        desc +
        '</div></div>';

      $element.after(_template);

      // Event
      const $gfSwitcher = $element.next();
      const $switch = $gfSwitcher.find('.gfSwitcherSwitch');

      // LAZYLOADING 2019
      const value = $element.attr('value') || this.settings.value;

      if (value && value == 1) {
        $switch.addClass('activeSwitch');
      } else {
        $switch.removeClass('activeSwitch');
      }
      _this.checkDynamic(value);

      // LAZYLOADING2019
      if (_this.settings.enable) {
        // COLLECTION 2019
        $switch.off('click').on('click', function () {
          const name = $element.attr('name');
          const newValue = $switch.hasClass('activeSwitch') ? 0 : 1;
          if (name == 'dynamic' && newValue == 1) {
            const $mdSettings = $gfLeftSideBar.find('#md-settings');
            const merId = $mdSettings.data('edittingID');
            const $targetElement = $gryffBody.find('#' + merId);
            const dynamicPLCount = $gryffBody.find(
              '.module-wrap[data-label="Product List"][data-status="dynamic"], .module-wrap[data-label="Product List"][data-status="default"]',
            ).length;
            if (
              dynamicPLCount > 0 &&
              $targetElement.attr('data-label') &&
              $targetElement.attr('data-label') == 'Product List'
            ) {
              HELPER.showNotify('There is a dynamic Product List already.', 'error');
              return false;
            }
          }

          if (!$($switch).hasClass('activeSwitch')) {
            var status = _this.settings.onBeforeChanged(1, $element);
            if (status || status == undefined) {
              $switch.addClass('activeSwitch');
              _this.onChangeValue(1, 'change');
            }
          } else {
            var status = _this.settings.onBeforeChanged(0, $element);
            if (status || status == undefined) {
              $switch.removeClass('activeSwitch');
              _this.onChangeValue(0, 'change');
            }
          }
        });
      }

      return false;
    };

    this.onChangeValue = function (value, type) {
      $element.val(value).attr('value', value).trigger('on-require');
      updateCurrentSettings($element.attr('id'), value);
      _this.settings.onSelected(value, $element);

      if (!_this.checkDynamic(value)) {
        if (type == 'change') {
          $element.trigger('input-change').trigger('history-change');
        }
      }
      return false;
    };

    this.setValue = function (value) {
      const $gfSwitcher = $element.next();
      const $switch = $gfSwitcher.find('.gfSwitcherSwitch');
      if (value == 1) {
        $switch.addClass('activeSwitch');
      } else {
        $switch.removeClass('activeSwitch');
      }
      _this.checkDynamic(value);
      $element.val(value).attr('value', value).trigger('on-require');
      updateCurrentSettings($element.attr('id'), value);
      return value;
    };

    this.checkDynamic = function (value) {
      const name = $element.attr('name');
      if (name == 'dynamic') {
        const $mdSettings = $gfLeftSideBar.find('#md-settings');
        const merId = $mdSettings.data('edittingID');
        const $targetElement = $gryffBody.find('#' + merId);
        if (value == '1') {
          $mdSettings.attr('data-status', 'dynamic');
          if ($targetElement.data('gfmodule') != undefined) {
            $targetElement.data('gfmodule').setDynamic(true);
            $targetElement.data('gfmodule').showTool();
          }
        } else {
          $mdSettings.removeAttr('data-status');
          if ($targetElement.data('gfmodule') != undefined) {
            $targetElement.data('gfmodule').setDynamic(false);
            $targetElement.data('gfmodule').showTool();
          }
        }
      }
    };

    this.init();
  };

  jQuery.fn.gfSwitcher = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfswitcher')) {
        const plugin = new jQuery.gfSwitcher(this, options);
        jQuery(this).data('gfswitcher', plugin);
      }
    });
  };
})(jQuery);
